import PrivateRoute from "components/PrivateRoute";
import Dashboard from "features/Admin";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SignIn from "./features/SignIn";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="admin/*"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<SignIn />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
